import { useState, useEffect } from 'react'
import { SectionHeading } from './SectionHeading'
import { Spinner } from '../../../components/Spinner'
import { CarGrid } from '../../../components/CarCards/CarGrid'

export function OtherDylerCars() {
  const [cars, setCars] = useState([])
  const [currency, setCurrency] = useState('')
  const [user, setUser] = useState('')
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    App.Request.get(`/car_contents/${App.State.carId}/other_dyler_cars.json`)
      .then(({ data, status }) => {
        if (status === 200) {
          setCars(data.cars)
          setCurrency(data.currency)
          setUser(data.user)
        } else {
          return null
        }
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])

  return (
    <div>
      {loading && <Spinner />}

      {!loading && cars.length > 0 && (
        <div id="other-dyler-cars">
          <SectionHeading
            title={I18n.t('more_vehicles_from_user', { user })}
            link={{
              url: `/${I18n.t('routes.cars')}?user_id=${App.State.sellerId}`,
              title: I18n.t('explore'),
            }}
          />
          <CarGrid cars={cars} currency={currency} />
        </div>
      )}
    </div>
  )
}
